'use strict';

var $ = require('jquery');
var _ = require('underscore');
var mediator = require('../../js/mediator');
var config = require('../../js/config');
var AjaxItemLoaderTemplate = require('./templates/AjaxItemLoader.hbs');
var AjaxItemLoaderErrorTemplate = require('./templates/AjaxItemLoaderError.hbs');

class AjaxItem {

  /**
   * @param options.el The wrapper element
   * @param options.url The url for the endpoint
   * @param options.hash An id within the response to load
   * @param options.replace Replace the AjaxLoader element with the results
   * @constructor
   */
  constructor(options) {
    _.extend(this, options);
    this.$el = $(this.el);
    this._initialize();
  }

  _initialize() {
    mediator.on(config.events.ajax.success, this._onAjaxSuccess, this);
    mediator.on(config.events.ajax.failed, this._onAjaxFailed, this);

    // Display loader if the element is empty
    if (!this.$el.html().trim()) {
      this.$el.html(AjaxItemLoaderTemplate);
    }
  }

  _onAjaxSuccess(data) {
    // Check if it was us
    if (!this._isOurEvent(data)) { return; }

    // Remove the event handlers as they are no longer needed
    mediator.off(config.events.ajax.success, this._onAjaxSuccess, this);
    mediator.off(config.events.ajax.failed, this._onAjaxFailed, this);

    if (data && data.response) {
      let dataResponse = JSON.parse(JSON.stringify(data.response));
      if (this.hash) {
        var $html = $(dataResponse).find(this.hash);
        this._setHtml($html.length ? $html.html() : undefined);
      } else {
        this._setHtml(dataResponse);
      }
    }

    mediator.trigger(config.events.ui.ajaxContentLoaded, this.$el);
  }

  _setHtml(html) {
    if (this.replace) {
      if (!html) {
        this.$el.remove();
      } else {
        let $html = $(html);
        this.$el.replaceWith($html);
        this.$el = $html;
      }
    } else {
      this.$el.html(html || '');
    }
  }

  _onAjaxFailed(data) {
    // Check if it was us
    if (!this._isOurEvent(data)) { return; }

    // Remove the event handlers as they are no longer needed
    mediator.off(config.events.ajax.success, this._onAjaxSuccess, this);
    mediator.off(config.events.ajax.failed, this._onAjaxFailed, this);

    this.$el.html(AjaxItemLoaderErrorTemplate);
  }

  _isOurEvent(data) {
    return (data.url === this.url);
  }

}

module.exports = AjaxItem;



// WEBPACK FOOTER //
// ./assets/components/AjaxLoader/AjaxItem.js